import * as Yup from "yup";

export const AdvKeyImageSchema = Yup.object({
  imageTitle: Yup.string()
    .min(1, "Key image title cannot be blank")
    .max(50, "Key image title length exceeds maximum allowed length i.e. 50")
    .required("Key image title cannot be blank"),
});
